module.exports = __webpack_public_path__ + "img/community-icon.941e4c00.svg";